<!--
    校区管理-学生管理-手动绑定新号
    功能：学生手动绑定手机号组件
    组件: el-form、el-form-item
-->
<template>
  <div class="wrapper">
    <div class="top">
      <div class="left">
        <img
          :onerror="studentInfo.gender === 1 ? moveErrorBoy : moveErrorGirl"
          :src="studentInfo.headimgurl ? studentInfo.headimgurl : ''"
          style="width:100px;height:100px">
        <div class="txt">头像</div>
      </div>
      <div class="right">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          size="medium"
          label-width="90px">
          <el-form-item label="学生名称："><span>{{ studentInfo.name }}</span></el-form-item>
          <el-form-item label="学生学号："><span>{{ studentInfo.number }}</span></el-form-item>
          <el-form-item label="原手机号："><span>{{ studentInfo.mobile }}</span></el-form-item>
          <el-form-item
            label="新手机号："
            style="margin-top:10px"
            prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="请输入手机号"/>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="bottom">
      <el-button @click="handlerClose">取 消</el-button>
      <el-button
        :loading="submitLoading"
        type="primary"
        @click="handlerUpdate"
      >确 定</el-button>
    </div>
  </div>
</template>

<script>
// import { updateStudentPhone } from '@/api/student';
import defaultBoy from '@/assets/images/student_boy.png';
import defaultGirl from '@/assets/images/student_girl.png';

export default {
  name: 'HanderBind',
  props: {
    studentInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      moveErrorBoy: `this.src="${defaultBoy}"`,
      moveErrorGirl: `this.src="${defaultGirl}"`,
      submitLoading: false,
      form: {
        phone: '',
      },
      rules: {
        phone: [
          this.$rules.required('新手机号'), { ...this.$rules.mobile },
        ],
      },
    };
  },
  methods: {
    // 更新绑定数据
    handlerUpdate() {
      // console.log('学生信息', this.studentInfo);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          const formData = new FormData();
          formData.append('student_id', this.studentInfo.id);
          formData.append('mobile', this.form.phone);
          this.$http.post('/api/student/bind-mobile', formData).then((res) => {
            this.submitLoading = false;
            if (res.status_code === 200 && res.code === 0) {
              this.$notify({
                title: 'Success',
                message: '修改成功',
                type: 'success',
                duration: 2000,
              });
              this.$emit('close-dialog');
              this.$emit('refresh-data');
              return;
            }
            this.$message.warning(res.message);
          }).catch(() => {
            this.submitLoading = false;
            this.$message.error('重新绑定手机号失败！');
          });
        }
      });
    },
    // 关闭窗口
    handlerClose() {
      this.$emit('close-dialog');
    },
  },
};
</script>

<style lang="scss" scoped>
  .top{
      display: flex;
      .left{
          width: 160px;
          margin-top: 10px;
          margin-right: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .txt{
            padding-top: 15px;
          }
      }
  }
  .bottom{
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
</style>




// WEBPACK FOOTER //
// src/views/Student/components/BindPhoneDialog/handerBind.vue